import { ActionTree } from 'vuex'
import { RootState } from '@/store/types'
import { EstacionesInterface, EstacionesService } from '@/domain/services/EstacionesService'
import { EstacionesState, StoreError } from '@/store/modules/estaciones/types'
import { format } from 'date-fns'

const estaciones: EstacionesInterface = new EstacionesService()

export const actions: ActionTree<EstacionesState, RootState> = {
  async getGrupoTipoVariable ({ commit }) {
    try {
      const actionResponse = await estaciones.getGrupoTipoVariables()
      return commit(actionResponse.type, actionResponse.payload)
    } catch (error) {
      const storeError: StoreError = { state: true, message: error, name: 'STORE_ERROR' }
      return commit('STORE_ERROR', storeError)
    }
  },
  async getTipoVariable ({ commit }, id) {
    try {
      const actionResponse = await estaciones.getTipoVariables(id)
      return commit(actionResponse.type, actionResponse.payload)
    } catch (error) {
      const storeError: StoreError = { state: true, message: error, name: 'STORE_ERROR' }
      return commit('STORE_ERROR', storeError)
    }
  },
  async getEstaciones ({ commit }, id) {
    try {
      const actionResponse = await estaciones.getEstaciones(id)
      return commit(actionResponse.type, actionResponse.payload)
    } catch (error) {
      const storeError: StoreError = { state: true, message: error, name: 'STORE_ERROR' }
      return commit('STORE_ERROR', storeError)
    }
  },
  async getDataEstacion ({ commit }, { estacion, variable, init, final }) {
    try {
      const initDate = format(init, 'yyyy-MM-dd')
      const finalDate = format(final, 'yyyy-MM-dd')
      const actionResponse = await estaciones.getEstacion(estacion, variable, initDate, finalDate)
      return commit(actionResponse.type, actionResponse.payload)
    } catch (error) {
      const storeError: StoreError = { state: true, message: error, name: 'STORE_ERROR' }
      return commit('STORE_ERROR', storeError)
    }
  },
  async resetDataEstacion ({ commit }) {
    try {
      return commit('DATA_ESTACION_RESET')
    } catch (error) {
      const storeError: StoreError = { state: true, message: error, name: 'STORE_ERROR' }
      return commit('STORE_ERROR', storeError)
    }
  },
  async getDataEstacionFromGrupoTipoVariable ({ commit }, { grupoTipoVariable, estacion }) {
    try {
      const actionResponse = await estaciones.getEstacionFromGrupoTipoVariable(grupoTipoVariable, estacion)
      return commit(actionResponse.type, actionResponse.payload)
    } catch (error) {
      const storeError: StoreError = { state: true, message: error, name: 'STORE_ERROR' }
      return commit('STORE_ERROR', storeError)
    }
  }
}
